// extracted by mini-css-extract-plugin
export default {"CommentsButton":"ij_a bhc_vr bhc_iv bhc_wf bhc_i bhc_j bhc_q bhc_un bhc_en bhc_ri bhc_rj bhc_cx","CommentsButton__icon":"ij_b bhc_re"};